/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import React, { useState } from 'react';
import AddIcon from "@mui/icons-material/Add";
// @mui
import {
  Card,
  Stack,
  Button,
  Popover,
  MenuItem,
  Container,
  Typography,
  Grid
} from '@mui/material';
import { useFormik } from "formik";
import * as yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

// components
// sections
// mock

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------



function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
const validationSchema = yup.object({
    nama: yup.string("Enter your password").required("Nama Tidak Boleh Kosong"),
    jabatan: yup
      .string("Enter your password")
      .required("Jabatan Tidak Boleh Kosong"),
    tanggal_gaji: yup
      .string("Enter your password")
      .required("Tanggal gaji Tidak Boleh Kosong"),
  });

export default function UserPage(props) {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { data } = props;

  const [status, setStatus] = React.useState("");
  const [rule, setRule] = React.useState([]);
  const [rulesname, setRulesname] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [severitylevel, setSeveritylevel] = React.useState("");
  const [channel, setChannel] = React.useState("");
  const [limit, setLimit] = React.useState("");
  const [action, setAction] = React.useState([]);
  const [actionsorted, setActionsorted] = React.useState([]);

  const capitalizeFirst = (str) => {
    const str1 = str.split("_").join(" ");
    return str1.charAt(0).toUpperCase() + str1.slice(1);
  };
  const formik = useFormik({
    initialValues: {
      nama: data && data.Nama,
      jabatan: (data && data.jabatan) || "",
      tanggal_gaji: (data && data.Tanggal_gaji) || "",
      gaji_pokok: (data && data.gaji_pokok) || "",
      pulsa: (data && data.pulsa) || "",
      tunjangan_hari_raya: (data && data.tunjangan_hari_raya) || "",
      tunjangan_kehadiran: (data && data.tunjangan_kehadiran) || "",
      tunjangan_luar_kota: (data && data.tunjangan_luar_kota) || "",
      dedikasi: (data && data.dedikasi) || "",
      bpjs_ketenagakerjaan: (data && data.bpjs_ketenagakerjaan) || "",
      setoran_bpjs_kesehatan: (data && data.setoran_bpjs_kesehatan) || "",
      setoran_bpjs_ketenagakerjaan:
        (data && data.setoran_bpjs_ketenagakerjaan) || "",
      potongan_kehadiran: (data && data.potongan_kehadiran) || "",
      kasbon_gaji: (data && data.kasbon_gaji) || "",
      gaji_bersih: (data && data.gaji_bersih) || "",
      jumlah_penerimaan: (data && data.Jumlah_penerimaan) || "",
      jumlah_potongan: (data && data.Jumlah_potongan) || "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {},
  });

  function save() {
    const newDate = new Date();
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    const separator = "-";

 const item = {
      rulesname,
      description,
      severitylevel,
      channel,
      limit,
      status,
      created_at: `${year}${separator}${
        month < 10 ? `0${month}` : `${month}`
      }${separator}${date}`,
      created_by: "system admin",
      data: rule,
      action: action,
      actionsorted: actionsorted,
    };
}
  const TextfieldCustom2 = ({
    id = "",
    size = "",
    titles = "",
    placeholder = "",
    dropdown = [],
    label = "",
    multiline = false,
    value = "",
    changer,
  }) => {
    return (
      <Grid item md={size}>
        <Grid container direction={"column"} spacing={0}>
          <Grid item>
            <Typography variant="subtitle2">{titles}</Typography>
          </Grid>
          <Grid item>
            {dropdown != "" ? (
              <Autocomplete
                fullWidth
                size="small"
                key={id}
                disablePortal
                value={(dropdown || []).find((e) => e[label] == value)}
                id={id}
                onChange={(event, newValue) => {
                  changer(newValue[label]);
                }}
                options={dropdown}
                getOptionLabel={(dropdown) =>
                  (dropdown && dropdown[label]) || ""
                }
                getOptionSelected={(option, selectedValue) =>
                  option[label] == selectedValue[label]
                }
                renderInput={(params) => (
                  <TextField
                    key={id}
                    onBlur={formik.handleBlur}
                    error={formik.touched[id] && Boolean(formik.errors[id])}
                    helperText={formik.touched[id] && formik.errors[id]}
                    {...params}
                    fullWidth
                    placeholder={capitalizeFirst(id)}
                  />
                )}
              />
            ) : (
              <TextField
                fullWidth
                id={id}
                multiline={multiline}
                name={id}
                size="small"
                placeholder={placeholder}
                //   label={capitalizeFirst(id)}
                value={value}
                onChange={(e) => {
                  changer(e.target.value);
                }}
                error={formik.touched[id] && Boolean(formik.errors[id])}
                helperText={formik.touched[id] && formik.errors[id]}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  function handleIncrementClick(index, value, e) {
    // console.log("awdawd");
    // console.log(value);
    // console.log(e);
    const nextCounters = rule.map((c, i) => {
      if (i == index) {
        // Increment the clicked counter
        return { ...c, [value]: e };
      } else {
        // The rest haven't changed
        return c;
      }
    });
    setRule(nextCounters);
    // console.log(rule);
  }

  

  return (
    <>
      <Helmet>
        <title> Add Watchlist | SmartShield </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Add Watchlist
          </Typography>
        </Stack>
        <Grid container direction={"row"} spacing={3}>
        {TextfieldCustom2({
              id: "watchlist_name",
              size: 6,
              titles: "Watchlist Name",
              placeholder: "Watchlist Name",
              value: rulesname,
              changer: setRulesname,
            })}
            {TextfieldCustom2({
              id: "severity_level",
              size: 6,
              titles: "Severity Level",
              placeholder: "level 1",
              dropdown: [
                { id: "Level 1" },
                { id: "Level 2" },
                { id: "Level 3" },
              ],
              label: "id",
              value: severitylevel,
              changer: setSeveritylevel,
            })}
            {TextfieldCustom2({
              id: "description",
              size: 4,
              titles: "Descriptions",
              placeholder: "Write a watchlist Description",
              multiline: true,
              value: description,
              changer: setDescription,
            })}
            {TextfieldCustom2({
              id: "status",
              size: 2,
              titles: "Status",
              dropdown: [{ id: "Active" }, { id: "inActive" }],
              label: "id",
              value: status,
              changer: setStatus,
            })}
            {TextfieldCustom2({
              id: "channel",
              size: 2,
              titles: "Channel",
              dropdown: [
                { id: "ATM" },
                { id: "EDC" },
                { id: "INTERNET BANKING" },
                { id: "BRANCH TELLER" },
                { id: "MOBILE BANKING" },
                { id: "SYSTEM ACCESS" },
                { id: "ALL CHANNEL" },
              ],
              label: "id",
              value: channel,
              changer: setChannel,
            })}
            {TextfieldCustom2({
              id: "limit",
              size: 2,
              titles: "Limit to",
              dropdown: [
                { id: "1" },
                { id: "2" },
                { id: "4" },
                { id: "5" },
                { id: "6" },
                { id: "7" },
                { id: "8" },
                { id: "9" },
                { id: "10" },
                { id: "11" },
                { id: "ALL" },
              ],
              label: "id",
              value: limit,
              changer: setLimit,
            })}
            
            <Grid item style={{ alignSelf: "flex-end" }}>
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                style={{
                  textTransform: "none",

                  backgroundColor: "#469A45",
                }}
                onClick={() => {
                  // rule.push({
                  //   id: rule.length,
                  // });
                  const insertAt = 1; // Could be any index
                  const nextArtists = [
                    // Items before the insertion point:
                    ...rule.slice(0, insertAt),
                    // New item:
                    {
                      id: rule.length,
                      if: "",
                      select_operator: "",
                      value: "",
                      parameter: "",
                      condition: "",
                      type: "",
                      select_operator2: "",
                    },
                    // Items after the insertion point:
                    ...rule.slice(insertAt),
                  ];
                  setRule(nextArtists);
                }}
              >
                Add Condition
              </Button>
            </Grid>
         </Grid>
      </Container>
    </>
  );
}
